import script from "./ClinicIndex.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClinicIndex.vue?vue&type=script&lang=ts&setup=true"

import "./ClinicIndex.vue?vue&type=style&index=0&id=232e0662&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-232e0662"]])

export default __exports__